import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { TipoSolicitudResponse } from '../../models/tipo-solicitud/tipo-solicitud.model';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root'
})
export class TipoSolicitudService {
  private readonly apiUrl = `${ENV.HOST}${URL_MAP.API.COTIZADOR_TIPO_SOLICITUD}`;
  
  constructor(private httpClient: HttpClient) { }

  /**
   * Consulta los tipos de solicitud disponibles
   * @returns Observable con la lista de tipos de solicitud
   */
  getTiposSolicitud(): Observable<TipoSolicitudResponse> {
    return this.httpClient.get<TipoSolicitudResponse>(this.apiUrl).pipe(
      map((response: TipoSolicitudResponse) => response),
      catchError(error => {
        let errorMessage: string;
        if (error.status === 404) {
          errorMessage = 'No se encontró el recurso de tipos de solicitud.';
        } else if (error.status === 500) {
          errorMessage = 'Error en el servidor al obtener tipos de solicitud.';
        } else {
          errorMessage = error.error?.message || 'Error al consultar tipos de solicitud.';
        }
        console.error('Error en getTiposSolicitud:', error);
        return throwError(() => errorMessage);
      })
    );
  }
}
